module.exports = __webpack_public_path__ + "img/line4.b697915c.svg";